import './chatWithSummaryNew.css';
import {
  Box,
  Button,
  Header,
  Modal,
  SpaceBetween,
  ExpandableSection,
  Container,
  Badge,
  Popover
} from '@cloudscape-design/components';
import { JSX, useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '../../../context/authContext';
import { createChatSummary } from '../../../helpers/createChatSummary';
import {
  ChatResponseSentence,
  citeOutline,
  documentTableItem,
  IChatSummary,
  outline
} from '../../../lib/models/interfaces';
import { TopicSummary } from './topicSummary';
import { ProjectContext } from '../../../context/projectContext';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { DocumentContext } from '../../../context/documentContext';
import { uniqueById, unzipJson } from './chatHelpers';
import { CitationText } from './chatAnswer';
import CiteBlockCard from './contextBlockCard';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { calculateComplianceCoins } from '../accountViews/helpers';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { getComponent } from './loadingPlaceHolder';
import { DocumentFilter, DocumentFilterHandle } from './documentFilter';
import { ScrollDownArrow } from '../shared/scrollDownArrow';
import { useAlert } from '../../../context/alertContext';
import { createLogger } from '../../../helpers/Logger';

const logger = createLogger({ prefix: '[ChatwithSummary]' });
export interface ICiteBlock {
  All_Parameters: any[];
  Context: {
    text: string;
    _id: string;
  };
  Document: {
    documentFileName: string;
    _id: string;
  };
  PageNumber?: number;
  pageNumber: number;
  knowledge_base_type: string;
  score: number;
  sentenceId: string;
  text: string;
  _id: string;
  outline?: outline[];
}

interface ChatWithSummaryProps {
  type: string;
  goToSpecificPage: (pageNo: number, index: number) => void;
  currentDocuments?: documentTableItem[];
  setOutline?: (outline: citeOutline[]) => void;
}

function extractHtmlAndSnippets(content: string): {
  htmlBeforeSnippets: string;
  parsedSnippets: Record<string, string[]>;
} {
  const [htmlPart, snippetPart] = content.split(/---SNIPPETS---/);
  logger.info('SNIPPET PART OF ANSWER', snippetPart);
  const htmlBeforeSnippets = htmlPart.trim();
  const parsedSnippets: Record<string, string[]> = {};

  const snippetRegex = /\{\{\{(.*?)\}\}\}/g;
  let match: RegExpExecArray | null;

  while ((match = snippetRegex.exec(snippetPart)) !== null) {
    const inner = match[1].trim();
    const [contextId, ...excerpts] = inner.split(':::').map((s) => s.trim());
    logger.info('context id in snippet', contextId);
    logger.info('exceprts', excerpts);
    const idOnly = /(?<=<<cid:)[0-9A-Fa-f]{24}(?=>>)/g;
    // usage:
    const ctxId = contextId.match(idOnly) ?? ['']; // ["689eed0b824119433587c064"]
    logger.info('ctx Id', ctxId);
    parsedSnippets[ctxId[0]!] = excerpts
      .map((excerpt) => excerpt.replace(/^"+|"+$/g, '').trim())
      .filter(Boolean);
  }

  return { htmlBeforeSnippets, parsedSnippets };
}

export const ChatWithSummaryNewSub: React.FC<ChatWithSummaryProps> = ({
  type,
  goToSpecificPage,
  currentDocuments,
  setOutline
}) => {
  const { token, auth, user } = useContext(UserContext);
  const { mainProjects, allFolders } = useContext(ProjectContext);
  const { allDocuments, currentDocId } = useContext(DocumentContext);
  const [queryParameters] = useSearchParams();
  const { setAlert, handleError, setSubsAlert } = useAlert();
  const navigate = useNavigate();
  const filterRef = useRef<DocumentFilterHandle>(null);

  logger.info('in chat user groups', user.groups);

  const containerRef = useRef<HTMLDivElement>(null);
  //! state
  const [inputText, setInputText] = useState<string>('');
  const [messages, setMessages] = useState<ChatResponseSentence[]>([]);
  const [summary, setSummary] = useState<any>({});
  const [topicSummary, setTopicSummary] = useState<IChatSummary>({});
  const [jobComplete, setJobComplete] = useState<boolean>(false);
  const [requestLoading, setRequestLoading] = useState<boolean>(false);
  const [projectSelectList, setProjectSelectList] = useState<
    OptionDefinition[]
  >([]);
  const [selectedProject, setSelectedProject] = useState<OptionDefinition[]>(
    []
  );
  const [folderSelectList, setFolderSelectList] = useState<OptionDefinition[]>(
    []
  );
  const [selectedFolders, setSelectedFolders] = useState<OptionDefinition[]>(
    []
  );
  // all needed for document filter
  const [documentsSelectList, setDocumentSelectList] = useState<
    OptionDefinition[]
  >([]);
  const [selectedDocuments, setSelectedDocuments] = useState<
    OptionDefinition[]
  >([]);
  const [kbFilters, setKBFilters] = useState<OptionDefinition[]>([]);
  const [KBChecked, setKBChecked] = useState<boolean>(false);
  const [searching, setSearching] = useState<boolean>(false);
  const [searchAnswer, setSearchAnswer] = useState<string>(``);
  const [citeBlocks, setCiteBlocks] = useState<ICiteBlock | null>(null);
  const [pinnedCiteBlocks, setPinnedCiteBlocks] = useState<ICiteBlock[]>([]);
  const [citeBlocksObject, setCiteBlocksObject] = useState<{
    [key: string]: ICiteBlock;
  }>({});
  const [showModal, setShowModal] = useState<boolean>(false);
  const [subQueries, setSubQueries] = useState<string[]>([]);
  const [allInfoObject, setAllInfoObject] = useState<{
    [key: string]: any[];
  }>({});
  const allInfoRef = useRef<{
    [key: string]: any[];
  }>({});
  const [tokenInfo, setTokenInfo] = useState<any[]>([]);
  const [tokenCost, setTokenCost] = useState<number>(0);
  const [currentDocsLocal, setCurrentDocsLocal] = useState<string[]>([]);
  const [awaitingAnswer, setAwaitingAnswer] = useState<boolean>(false);

  // coins state

  const [showCoinsModal, setShowCoinsModal] = useState<{
    visible: boolean;
    type: string;
  }>({ visible: false, type: '' });
  const [similarityThreshold, setSimilarThreshold] = useState<number>(0.8);
  const [prevChecked, setPrevChecked] = useState<boolean>(false);
  const [filterIsOpen, setFilterIsOpen] = useState<boolean>(false);
  const [citedBlocksIds, setCitedBlocksIds] = useState<string[]>([]);
  const [snippetInfo, setSnippetInfo] = useState<{ [key: string]: string[] }>();
  const [snippetSentences, setSnippetSentences] = useState<{
    [key: string]: {
      outline: outline[];
      text: string;
      _id: string;
      PageNumber: number;
    }[];
  }>();
  const [component, setComponent] = useState<JSX.Element>();
  const [citationIndexes, setCitationIndexes] = useState<{
    [key: string]: number;
  }>();

  logger.info('current docs in chatwith summary', currentDocuments);
  // create the websocket connection

  useEffect(() => {
    logger.info('snippet info', snippetInfo);
  }, [snippetInfo]);
  useEffect(() => {
    const ids = queryParameters.getAll('documentId');
    setCurrentDocsLocal(ids);
  }, []);
  const setProjectsOptions = () => {
    const optionsArray = mainProjects
      .filter((ele) => ele.projectType === 'workspace')
      .map((ele) => {
        return {
          label: ele.projectName,
          value: ele._id
        };
      });
    setProjectSelectList(optionsArray);
  };
  useEffect(() => {
    if (mainProjects.length > 0) {
      setProjectsOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainProjects]);
  useEffect(() => {
    if (selectedProject.length > 0) {
      const projectIds = selectedProject.map((ele) => ele.value);
      const foldersArray = allFolders.filter((ele) =>
        projectIds.includes(ele.project)
      );
      const folderOptionList = foldersArray.map((ele) => {
        return { label: ele.folderName, value: ele._id };
      });
      setFolderSelectList(folderOptionList);
    } else {
      setFolderSelectList([]);
      setDocumentSelectList([]);
      setSelectedFolders([]);
      setSelectedDocuments([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject]);

  useEffect(() => {
    if (selectedFolders.length === 0) {
      setDocumentSelectList([]);
      setSelectedDocuments([]);
    }
    if (allDocuments.length === 0) {
      // setShowCoinsModal({ visible: true, type: 'NoDocs' });
      return;
    }
    const folderIds = selectedFolders.map((ele) => ele.value);
    const filteredDocs = allDocuments.filter((ele) =>
      folderIds.includes(ele.folder)
    );
    const docOptions = filteredDocs.map((ele) => {
      return { label: ele.documentFileName, value: ele._id };
    });
    setDocumentSelectList(docOptions);
  }, [allDocuments, selectedFolders]);

  // websocket connection

  // const getAvailableCoins = async () => {
  //   try {
  //     const resultAvailCoins = await axios.post(
  //       `${process.env.REACT_APP_KORU_API}/document?type=availableCoinsByCustomer`,
  //       {},
  //       auth
  //     );
  //     logger.info('result Available coins', resultAvailCoins);
  //     return resultAvailCoins.data.result;
  //   } catch (e) {
  //     logger.error('error from available coins', e);
  //   }
  // };

  function extractIdsFromAnswer(text: string): string[] {
    // const regex = /‹(.*?)›/g;
    const regex = /<<cid:([A-Fa-f0-9]{24})>>/g;
    const matches: string[] = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
      if (!matches.includes(match[1])) {
        matches.push(match[1]);
      }
    }

    return matches;
  }

  const getSnippetSentences = async (snippetInfo: {
    [key: string]: string[];
  }) => {
    if (!token) return;
    try {
      //TODO move this into its own entity
      logger.info('snippet info before send', snippetInfo);
      const result = await axios.post(
        `${process.env.REACT_APP_KORU_API}/sentence?type=snippetInfo`,
        { snippets: snippetInfo },
        auth
      );
      logger.info('result snippet info', result.data.result);
      setSnippetSentences(result.data.result);
    } catch (e) {
      const error = e as Error;
      logger.error('error from get snippet sentences', error.message);
    }
  };

  useEffect(() => {
    if (snippetInfo) {
      getSnippetSentences(snippetInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snippetInfo]);

  const reset = () => {
    setMessages([]);
    setTopicSummary({});
    setSearching(false);
    setSummary({});
    setJobComplete(false);
    setRequestLoading(false);
    setPinnedCiteBlocks([]);
    setSubQueries([]);
    setCiteBlocksObject({});
    setCiteBlocks(null);
    setAllInfoObject({});
    allInfoRef.current = {};
    setSearchAnswer('');
    setSelectedProject([]);
    setSelectedDocuments([]);
    setSelectedFolders([]);
    setTokenCost(0);
    setCitedBlocksIds([]);
    setComponent(undefined);
    setInputText('');
    filterRef.current?.reset();
  };

  const getAndSetAnswers = (computedAnswer: { text: string }[]) => {
    const answersMapped = computedAnswer.map(
      (ele: { text: string }) => ele.text
    );
    logger.info('answers mapped', answersMapped);
    const answerInfo = extractHtmlAndSnippets(answersMapped.join('\n\n'));
    logger.info('parsedSnippets', answerInfo.parsedSnippets);
    logger.info('Html before snippets', answerInfo.htmlBeforeSnippets);

    setSnippetInfo(answerInfo.parsedSnippets);

    setSearchAnswer(answerInfo.htmlBeforeSnippets);
    setComponent(undefined);
    const getContextIds = extractIdsFromAnswer(answersMapped.join('\n\n'));
    logger.info('GetCOntextIds', getContextIds);
    // parse the snippets from the computed
    // console.log('getCOntextIds in setAnswer', getContextIds);
    setCitedBlocksIds(getContextIds);
  };

  // // testing the 800 char question websocket call
  const searchAndAwaitStartSearch = async (typeResearch: string) => {
    setSearching(true);
    setMessages([]);
    setTopicSummary({});
    setSummary({});
    setJobComplete(false);
    setRequestLoading(true);
    setPinnedCiteBlocks([]);
    setSubQueries([]);
    setCiteBlocksObject({});
    setCiteBlocks(null);
    setAllInfoObject({});
    allInfoRef.current = {};
    setSearchAnswer('');
    setComponent(undefined);

    // calculate the number of coins needed to hold and if there are not enough let the user know to buy more.
    const requestId = uuidv4();
    let documentIds: string[] = [];
    if (type !== 'sub') {
      documentIds = selectedDocuments.map((ele) => ele.value!);
    } else {
      documentIds = currentDocsLocal;
    }
    let haveEnoughCoins = false;
    haveEnoughCoins = await haveEnoughCoinsForSearch(requestId);

    // try {
    //   haveEnoughCoins = await haveEnoughCoinsForSearch(requestId);
    // } catch (e) {
    //   alert('Not Enough Credit');
    // }
    if (!haveEnoughCoins) {
      setSearching(false);
    }
    // if there are enough coins make the calls else show the modal and have them buy more.
    if (haveEnoughCoins) {
      setSearching(true);
      const customHeaders = {
        Authorization: `Bearer ${token}`,
        type: 'chat'
      };
      const queryParams = new URLSearchParams(customHeaders).toString();
      let pingInterval: NodeJS.Timeout;
      const ws = new WebSocket(`${process.env.REACT_APP_WS}?${queryParams}`);
      ws.onopen = () => {
        logger.info('WebSocket connection established');

        pingInterval = setInterval(
          () => {
            if (ws?.readyState === WebSocket.OPEN) {
              ws.send(JSON.stringify({ type: 'ping' }));
              logger.info('Ping sent');
            }
          },
          5 * 60 * 1000
        ); // 4 minutes
        ws.send(
          JSON.stringify({
            action: 'searchStart',
            message: [
              {
                text: inputText,
                _id: 'testId',
                messageToken: `${token}`,
                searchKB: KBChecked,
                prevChecked: prevChecked,
                documentIds: documentIds,
                kbType: kbFilters.map((ele) => ele.value),
                requestId,
                modelId:
                  typeResearch === 'd'
                    ? 'arn:aws:bedrock:us-west-2:674674125182:inference-profile/us.deepseek.r1-v1:0'
                    : 'openai.gpt-oss-120b-1:0'
              }
            ]
          })
        );
      };
      // Handle incoming messages
      ws.onmessage = (event) => {
        const parsedData = JSON.parse(event.data);
        if (parsedData.type === 'content' && parsedData.sentence) {
          setMessages((prevState) => [...prevState, parsedData.sentence]);
        }
        if (parsedData.type === 'summary') {
          setSummary(parsedData);
        }
        if (parsedData.type === 'sub-query') {
          const subArray: string[] = parsedData.data;
          for (let i = 0; i < subArray.length; i++) {
            setTimeout(() => {
              setSubQueries((prevState) => [...prevState, subArray[i]]);
            }, i * 1000);
          }
        }
        if (parsedData.type === 'sub-answer') {
          const unzipped: { [key: string]: any[] } = unzipJson(parsedData.data);
          const key = Object.keys(unzipped);
          if (allInfoRef.current.hasOwnProperty(key[0])) {
            allInfoRef.current[key[0]] = [
              ...allInfoRef.current[key[0]],
              ...unzipped[key[0]]
            ];
          } else {
            allInfoRef.current = {
              ...allInfoRef.current,
              ...unzipped
            };
          }
          setAllInfoObject(allInfoRef.current);
          setAwaitingAnswer(true);
        }
        if (parsedData.type === 'answer') {
          if (parsedData.data.computedAnswer.length > 0) {
            // const sampleData = sampleAnswer2;
            getAndSetAnswers(parsedData.data.computedAnswer);
            // getAndSetAnswers(sampleData.computedAnswer);
          } else {
            setSearchAnswer(`
              <h2>No Available Information</h2>
              <p>We couldn’t find any results matching your query in the documents you selected. Try widening your search or including more documents to discover more insights!</p>
              `);
          }
          setJobComplete(true);
          setSearching(false);
          setAwaitingAnswer(false);

          // setCiteBlocksObject(parsedData.data.answerObject);
        }
        if (parsedData.type === 'Next Step') {
          const tempComponent = getComponent(parsedData.data);
          setComponent(tempComponent);
        }
        if (parsedData.type === 'error') {
          const tempComponent = getComponent('Error');
          setComponent(tempComponent);
          setSearching(false);
        }
        if (parsedData.type === 'answer-complete') {
          if (parsedData?.data) {
            setTokenInfo(parsedData?.data);
          }
          setJobComplete(true);
          setSearching(false);

          const allCiteBlocksArray = [];
          const answerkeys = Object.keys(allInfoRef.current);
          logger.info('answer keys', answerkeys);
          for (const key of answerkeys) {
            const blocks = allInfoRef.current[key];
            allCiteBlocksArray.push(...blocks);
          }

          const uniqueContexts = uniqueById(allCiteBlocksArray);
          const answerObject = uniqueContexts.reduce(
            (acc, curr) => {
              acc[curr._id] = curr;
              return acc;
            },
            {} as { [key: string]: any }
          );
          setCiteBlocksObject(answerObject);

          ws.close();
        }
      };
      ws.onerror = (error) => {
        logger.error('WebSocket error:', error);

        setAlert('Unauthorized', 'error', 5);
        setSearching(false);
      };
      // Handle connection close
      ws.onclose = (event) => {
        logger.info('WebSocket connection closed', event);
      };
    }
  };

  const handleChatSummary = () => {
    // logger.info('messages to summary chat', messages);
    const summaryResult = createChatSummary(messages);
    // logger.info('topic summary', JSON.stringify(summaryResult));
    setTopicSummary(summaryResult);
  };
  useEffect(() => {
    if (jobComplete) {
      handleChatSummary();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobComplete]);

  const handleCite = (id: string) => {
    // alert(`Cite clicked - ${id}`);
    // logger.info('cite block', id);
    const citeBlock = citeBlocksObject[id];

    logger.info('cite block', citeBlock);
    logger.info('Snippt Sentencs', snippetSentences);
    setCiteBlocks(citeBlock);

    // setShowModal(true);
    if (type === 'sub' && setOutline) {
      // logger.info('This cite block phrases', snippetInfo[citeBlock?._id]);
      // get outline
      const docIndex = currentDocuments?.findIndex(
        (ele) => ele._id === citeBlock?.Document?._id
      );
      goToSpecificPage(citeBlock?.pageNumber!, docIndex!);
      // setOutline(individualSentences);
    }
    if (type !== 'sub') {
      setShowModal(true);
    }
  };

  const pinCiteBlock = (id: string, pinAdd: boolean) => {
    const citeBlock = citeBlocksObject[id];
    // logger.info('cite block', citeBlock);
    if (pinAdd) {
      const isBlockAlreadyPinned = pinnedCiteBlocks.some(
        (block) => block._id === citeBlock._id
      );
      if (!isBlockAlreadyPinned) {
        setPinnedCiteBlocks((prevState) => [...prevState, citeBlock]);
      }
    }
    if (!pinAdd) {
      const updatedPinnedCiteBlocks = pinnedCiteBlocks.filter(
        (block) => block._id !== citeBlock._id
      );
      setPinnedCiteBlocks(updatedPinnedCiteBlocks);
    }
  };

  const canSearch = () => {
    if (type === 'sub') {
      if (inputText.length > 0) {
        return false;
      } else {
        return true;
      }
    } else {
      // logger.info('input text length', inputText.length);
      // logger.info('kb checked', KBChecked);
      // logger.info('selected documents', selectedDocuments.length);
      if (inputText.length > 0 && (KBChecked || selectedDocuments.length > 0)) {
        return false;
      } else {
        return true;
      }
    }
  };
  useEffect(() => {
    if (tokenInfo.length > 0) {
      let inputCount = 0;
      let outputCount = 0;
      tokenInfo.forEach((ele) => {
        inputCount += ele.tokensIn;
        outputCount += ele.tokensOut;
      });
      const costInput = ((inputCount / 1000) * 0.00135) / 0.3;
      const costOutput = ((outputCount / 1000) * 0.0054) / 0.3;
      const totalCost = costInput + costOutput;
      const rounded = Math.round(totalCost * 100) / 100;
      const complianceCoins = calculateComplianceCoins(inputCount, outputCount);

      setTokenCost(complianceCoins);
    }
  }, [tokenInfo]);

  async function haveEnoughCoinsForSearch(requestId: string) {
    let documentIds: string[] = [];
    if (type !== 'sub') {
      documentIds = selectedDocuments.map((ele) => ele.value!);
    } else {
      documentIds = currentDocsLocal;
    }
    try {
      const creditHold = await axios.post(
        `${process.env.REACT_APP_KORU_API}/credit?type=createCreditHold`,
        {
          type: 'search',

          documentIds,
          kbChecked: KBChecked
        },
        auth
      );
      if (creditHold?.data?.result?._id) {
        return true;
      }
      console.log('not enpugh credit.', creditHold?.data?.result?.message);
      if (creditHold?.data?.result?.message === 'Not Enough Credit Available') {
        console.log();
        setShowCoinsModal({ visible: true, type: 'BuyMore' });
        return false;
      }
      return false;
    } catch (e: any) {
      logger.error('error getting available coins', e.message);
      const error = e as Error;
      handleError(error.message);
      return false;
    }
  }

  return (
    <div>
      <div
        className="relative h-screen overflow-y-auto"
        ref={containerRef}
        style={{ scrollbarWidth: 'none' }}
      >
        <SpaceBetween size={'xs'}>
          <div className="flex gap-4">
            <textarea
              // type="text"
              rows={3}
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              className="flex-1 px-4 py-2 border rounded-md bg-blue-50"
              placeholder="Ask a question ..."
            />
          </div>
          <div className="flex flex-row justify-end p-1 gap-4">
            <Button onClick={() => reset()}>Clear All</Button>
            {/* <Button onClick={() => handleBuyMore()}>Buy More</Button> */}
            <Button
              onClick={() => {
                setFilterIsOpen(false);
                searchAndAwaitStartSearch('d');
              }}
              loading={searching}
              disabled={canSearch()}
            >
              Generate AI Findings
            </Button>
          </div>

          {Object.keys(topicSummary)?.length > 0 ? (
            <TopicSummary topicSummary={topicSummary} />
          ) : null}

          {jobComplete && searchAnswer?.length > 10 && (
            <div>
              <div className="w-full  flex flex-row items-center justify-between">
                <div>
                  <h3 className="text-xl">AI Findings</h3>
                  <p>Based on Your Question and Document Contents</p>
                </div>
                <Popover
                  position="top"
                  size="small"
                  dismissButton={true}
                  content="This shows the estimated compliance coins used for this search."
                >
                  {/* <Badge color="red">{tokenCost}</Badge> */}
                </Popover>
              </div>

              <div className="p-2">
                <div className="p-4 bg-white rounded-2xl shadow-xl flex flex-col">
                  <CitationText
                    text={searchAnswer}
                    onCiteClick={handleCite}
                    prevAnswer={false}
                    setCitationIndexes={setCitationIndexes}
                  />
                </div>
              </div>
            </div>
          )}
          {jobComplete && searchAnswer === '' && (
            <Container header={<Header>Search Results</Header>}>
              <SpaceBetween direction="vertical" size={'xs'}>
                <Box variant="p">
                  There appear to be no results for your search, please try a
                  different search term or change the scope of your search.
                </Box>
              </SpaceBetween>
            </Container>
          )}
          {!jobComplete && component && <>{component}</>}

          {searching && subQueries.length > 0 && !jobComplete ? (
            <div>
              <div className="w-full p-4 flex flex-row items-center justify-between">
                <h3 className="text-xl">The User is asking about </h3>
              </div>
              <div className="p-4">
                <div className="p-4 bg-white rounded-2xl shadow-xl flex flex-col">
                  {subQueries.map((ele) => {
                    return (
                      <Box key={ele} variant="p">
                        {ele}
                      </Box>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}
          {pinnedCiteBlocks.length > 0 && (
            <div>
              <div className="w-full p-4 flex flex-row items-center justify-between">
                <h3 className="text-xl">Pinned Citations </h3>
              </div>
              <div className="p-4">
                <div className="p-4 bg-white rounded-2xl shadow-xl flex flex-col">
                  {pinnedCiteBlocks.map((ele) => {
                    return (
                      <CiteBlockCard
                        key={ele._id}
                        citeBlock={ele}
                        auth={auth}
                        pinCiteBlock={pinCiteBlock}
                        pinAdd={false}
                        view={type === 'sub' ? 'simple' : ''}
                        goToSpecificPage={goToSpecificPage}
                        closeModal={setShowModal}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </SpaceBetween>

        <Modal
          visible={showCoinsModal.visible}
          onDismiss={() => setShowCoinsModal({ visible: false, type: '' })}
        >
          <>
            {showCoinsModal.type === 'BuyMore' ? (
              <div>
                <p className="text-sm text-gray-700 mb-4">
                  You do not have enough Compliance Credits to perform this
                  search. To continue using advanced features like document
                  analysis and AI answers, additional credits are required.
                </p>
                {user?.isAdmin ? (
                  <Button
                    onClick={() => {
                      setShowCoinsModal({ visible: false, type: '' });
                      setSubsAlert('', 'coins');
                    }}
                    // className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
                  >
                    Buy More Credits
                  </Button>
                ) : (
                  <button
                    className="bg-gray-400 text-white font-medium py-2 px-4 rounded cursor-not-allowed"
                    disabled
                  >
                    Contact your administrator to purchase more credits
                  </button>
                )}
              </div>
            ) : null}
            {showCoinsModal.type === 'Warning' ? (
              <div>
                <p className="text-sm text-gray-700 mb-4">
                  You are running low on compliance credits. To continue using
                  advanced features like document analysis and AI answers, we
                  suggest buying additional coins to prevent interruptions.
                </p>
                {user?.isAdmin ? (
                  <p className="text-sm text-gray-700 mb-4">
                    Navigate to the "View Credit Usage" page to purchase more.
                  </p>
                ) : (
                  <p className="text-sm text-gray-700 mb-4">
                    Contact you administrator to have them purchase more.
                  </p>
                )}
              </div>
            ) : null}
          </>
        </Modal>
        <ScrollDownArrow
          containerRef={containerRef as React.RefObject<HTMLElement>}
          bottomValue="12%"
        />
      </div>
    </div>
  );
};
